import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { PersonModal } from './PersonModal';
import { AppData } from '../../types';
import { Plus, User, Phone, FileText } from 'lucide-react';
interface PeopleTabProps {
  data: AppData;
  onAddPerson: (person: any) => void;
}
export function PeopleTab({
  data,
  onAddPerson
}: PeopleTabProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <div className="space-y-6 max-w-5xl mx-auto" data-id="element-279">
      <div className="flex justify-between items-center" data-id="element-280">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-281">People Involved</h2>
        <Button onClick={() => setIsModalOpen(true)} leftIcon={<Plus className="w-4 h-4" data-id="element-283" />} data-id="element-282">
          Add Person
        </Button>
      </div>

      {data.people.length === 0 ? <div className="text-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-200" data-id="element-284">
          <p className="text-gray-500 mb-4" data-id="element-285">No people documented yet</p>
          <Button variant="secondary" onClick={() => setIsModalOpen(true)} data-id="element-286">
            Add a Person
          </Button>
        </div> : <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-287">
          {data.people.map(person => <Card key={person.id} hover className="flex flex-col h-full" data-id="element-288">
              <div className="flex items-start justify-between mb-4" data-id="element-289">
                <div className="bg-purple-100 p-3 rounded-full" data-id="element-290">
                  <User className="w-6 h-6 text-purple-600" data-id="element-291" />
                </div>
                <Badge variant="gray" data-id="element-292">{person.role}</Badge>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-293">
                {person.name}
              </h3>

              <div className="space-y-3 flex-1" data-id="element-294">
                {person.contact && <div className="flex items-start gap-2 text-sm text-gray-600" data-id="element-295">
                    <Phone className="w-4 h-4 mt-0.5" data-id="element-296" />
                    <span data-id="element-297">{person.contact}</span>
                  </div>}
                {person.notes && <div className="flex items-start gap-2 text-sm text-gray-600" data-id="element-298">
                    <FileText className="w-4 h-4 mt-0.5" data-id="element-299" />
                    <p className="line-clamp-3" data-id="element-300">{person.notes}</p>
                  </div>}
              </div>
            </Card>)}
        </div>}

      <PersonModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={onAddPerson} data-id="element-301" />
    </div>;
}